<template>
  <v-row></v-row>
</template>

<script>
export default {
  name: "Unsubscribe"
}
</script>

<style scoped>

</style>
